var PolygonShape =
/** @class */
function () {
  function PolygonShape() {
    var points = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      points[_i] = arguments[_i];
    }

    var flat = Array.isArray(points[0]) ? points[0] : points; // if this is an array of points, convert it to a flat array of numbers

    if (typeof flat[0] !== 'number') {
      var p = [];

      for (var i = 0, il = flat.length; i < il; i++) {
        p.push(flat[i].x, flat[i].y);
      }

      flat = p;
    }

    this.points = flat;
    /**
     * `false` after moveTo, `true` after `closePath`. In all other cases it is `true`.
     * @member {boolean}
     * @default true
     */

    this.closeStroke = true;
  }

  PolygonShape.prototype.clone = function () {
    var points = this.points.slice();
    var polygon = new PolygonShape(points);
    polygon.closeStroke = this.closeStroke;
    return polygon;
  };

  PolygonShape.prototype.contains = function (x, y) {
    var inside = false; // use some raycasting to test hits
    // https://github.com/substack/point-in-polygon/blob/master/index.js

    var length = this.points.length / 2;

    for (var i = 0, j = length - 1; i < length; j = i++) {
      var xi = this.points[i * 2];
      var yi = this.points[i * 2 + 1];
      var xj = this.points[j * 2];
      var yj = this.points[j * 2 + 1];
      var intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;

      if (intersect) {
        inside = !inside;
      }
    }

    return inside;
  };

  return PolygonShape;
}();

export { PolygonShape };